{
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "confirm": "Confirm",
    "retry": "Retry",
    "edit": "Edit",
    "delete": "Delete",
    "create": "Create",
    "submit": "Submit",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "refresh": "Refresh"
  },
  "nav": {
    "reception": "Reception",
    "hospitality": "Hospitality",
    "intelligence": "Intelligence",
    "settings": "Settings"
  },
  "auth": {
    "signIn": "Sign in",
    "signOut": "Sign out",
    "email": "Email",
    "password": "Password",
    "emailPlaceholder": "Enter your email",
    "passwordPlaceholder": "Enter your password",
    "forgotPassword": "Forgot password?",
    "errors": {
      "invalidCredentials": "Invalid email or password",
      "sessionExpired": "Your session has expired. Please sign in again.",
      "unauthorized": "You are not authorized to access this resource.",
      "forbidden": "Access denied.",
      "networkError": "Unable to connect. Please check your connection.",
      "unknown": "An unexpected error occurred. Please try again."
    }
  },
  "states": {
    "loading": "Loading…",
    "loadingTitle": "Loading",
    "empty": "No results",
    "emptyTitle": "Nothing here yet",
    "error": "Something went wrong",
    "errorTitle": "Error",
    "noData": "No data available",
    "offline": "You appear to be offline"
  },
  "calls": {
    "title": "Calls",
    "liveTitle": "Live Calls",
    "active": "Active",
    "completed": "Completed",
    "missed": "Missed",
    "duration": "Duration",
    "language": "Language",
    "caller": "Caller",
    "summary": "Summary",
    "transcript": "Transcript",
    "handoff": "Hand off to staff",
    "noActiveCalls": "No active calls right now",
    "callHistory": "Call history"
  },
  "reservations": {
    "title": "Reservations",
    "new": "New reservation",
    "checkIn": "Check-in",
    "checkOut": "Check-out",
    "guestName": "Guest name",
    "roomType": "Room type",
    "status": "Status",
    "notes": "Notes",
    "noReservations": "No reservations found"
  },
  "bookings": {
    "title": "Bookings",
    "confirm": "Confirm booking",
    "cancel": "Cancel booking",
    "draft": "Draft",
    "confirmed": "Confirmed",
    "cancelled": "Cancelled",
    "noBookings": "No bookings found"
  },
  "tasks": {
    "title": "Tasks",
    "new": "New task",
    "assignee": "Assignee",
    "priority": "Priority",
    "dueDate": "Due date",
    "status": "Status",
    "open": "Open",
    "inProgress": "In progress",
    "done": "Done",
    "noTasks": "No tasks found"
  },
  "knowledge": {
    "title": "Knowledge",
    "documents": "Documents",
    "faq": "FAQ",
    "gaps": "Gaps",
    "search": "Search knowledge base",
    "approve": "Approve",
    "deactivate": "Deactivate",
    "archive": "Archive",
    "noDocuments": "No documents found"
  }
}
